export const heroStartTimes = [0, 7.5, 11.4, 31, 41, 50] as const;

const visitedCookie = 'cartwheel_homepage_hero_v2_visited';

function heroStartOverride(search: string): number | null {
  const override = new URLSearchParams(search).get('heroStart');
  if (override !== null && override.trim() !== '') {
    const startTime = Number(override);
    if (Number.isFinite(startTime) && startTime >= 0) return startTime;
  }
  return null;
}

export function chooseHeroStart(search: string, random = Math.random): number {
  const override = heroStartOverride(search);
  if (override !== null) return override;
  return heroStartTimes[Math.floor(random() * heroStartTimes.length)];
}

export function chooseHomepageHeroStart(
  search: string,
  cookies: Pick<Document, 'cookie'>,
  protocol: string,
  random = Math.random,
): number {
  const override = heroStartOverride(search);
  if (override !== null) return override;

  try {
    const hasVisited = () =>
      cookies.cookie
        .split(';')
        .some((part) => part.trim() === `${visitedCookie}=1`);

    if (hasVisited()) return chooseHeroStart('', random);

    cookies.cookie = `${visitedCookie}=1; Max-Age=31536000; Path=/; SameSite=Lax${
      protocol === 'https:' ? '; Secure' : ''
    }`;
    // A blocked or unavailable cookie must not count as a completed first visit.
    if (!hasVisited()) return 0;
  } catch {
    return 0;
  }

  return 0;
}
